import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';

const useStyles = buildUseStyles('TabNotFoundLayout', () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const TabNotFoundLayout = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Subtitle
        value={'Tab Not Found'}
      />
    </Box>
  );
};

TabNotFoundLayout.defaultProps = {
  className: '',
};

TabNotFoundLayout.propTypes = {
  className: PropTypes.string,
};

export default TabNotFoundLayout;
